var MfeApplicationEnum;
(function (MfeApplicationEnum) {
    MfeApplicationEnum["CoreMfe"] = "core-mfe";
    MfeApplicationEnum["LibraryMfe"] = "library-mfe";
    MfeApplicationEnum["DashboardMfe"] = "dashboard-mfe";
    MfeApplicationEnum["ProjectsMfe"] = "projects-mfe";
    MfeApplicationEnum["LegacyMfe"] = "legacy-mfe";
    MfeApplicationEnum["SessionsMfe"] = "sessions-mfe";
    MfeApplicationEnum["DistributionMfe"] = "distribution-mfe";
    MfeApplicationEnum["AccountMfe"] = "account-mfe";
    MfeApplicationEnum["BillingMfe"] = "billing-mfe";
    MfeApplicationEnum["PluginsMfe"] = "plugins-mfe";
    MfeApplicationEnum["NetworkMfe"] = "network-mfe";
})(MfeApplicationEnum || (MfeApplicationEnum = {}));

export { MfeApplicationEnum };
